import { OneClickProfileActionTypes, OneClickProfileActions } from '../actions/one-click-profile.actions';
import { OneClickQuantityActions, OneClickQuantityActionTypes } from '../actions/one-click-quantity.actions';

export interface OneClickQuantityState {
  value: number[];
}

export const initialState: OneClickQuantityState = {
  value: [],
};

export function reducer(
  state = initialState,
  action: OneClickQuantityActions | OneClickProfileActions,
): OneClickQuantityState {
  switch (action.type) {
    case OneClickQuantityActionTypes.SET_QUANTITY: {
      state.value[action.index] = 0;
      return {
        ...state,
        value: state.value.map((item, index) => {
          if (index === action.index) {
            return action.payload;
          } else {
            return item;
          }
        }),
      } as OneClickQuantityState;
    }
    case OneClickProfileActionTypes.RESET_BUILDER:
    case OneClickQuantityActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
